import { useCallback, useState } from 'react';

/** An input change; the user search passes a plain object with the value it sets */
export type SearchInputChange = {
    target: { value: string };
    preventDefault?: () => void;
    stopPropagation?: () => void;
};

/** A click on the search field, or the "/" key that opens it */
export type SearchOpenEvent = {
    preventDefault: () => void;
    stopPropagation: () => void;
};

/** The text of a search field and whether its dropdown is open */
export const useSearchInputField = () => {
    const [inputValue, setInputValue] = useState('');
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const handleReset = useCallback(() => {
        setInputValue('');
        setTooltipVisible(false);
    }, []);

    const handleInputChange = useCallback((event: SearchInputChange) => {
        event.preventDefault?.();
        event.stopPropagation?.();

        setInputValue(event.target.value);
    }, []);

    const handleInputClick = useCallback((event: SearchOpenEvent) => {
        event.preventDefault();
        event.stopPropagation();

        setTooltipVisible(true);
    }, []);

    return { inputValue, tooltipVisible, handleReset, handleInputChange, handleInputClick };
};
